export enum FORM {
  // contacts
  ADD_PARTY_RELATIONSHIP = "ADD_PARTY_RELATIONSHIP",
  EDIT_PARTY_RELATIONSHIP = "EDIT_PARTY_RELATIONSHIP",
  // projects
  ADD_EDIT_PROJECT_SUMMARY = "ADD_EDIT_PROJECT_SUMMARY",
  ADD_MINE_MAJOR_APPLICATION = "ADD_MINE_MAJOR_APPLICATION",
  ADD_EDIT_AMS_FINAL_APPLICATION = "ADD_EDIT_AMS_FINAL_APPLICATION",
  // reports
  VIEW_EDIT_REPORT = "VIEW_EDIT_REPORT",
  FILTER_REPORTS = "FILTER_REPORTS",
  // permits
  REVOKE_DIGITAL_CREDENTIAL = "REVOKE_DIGITAL_CREDENTIAL",
  REQUEST_REPORT = "REQUEST_REPORT",
  ADD_REPORT_TO_PERMIT_CONDITION = "ADD_REPORT_TO_PERMIT_CONDITION",
  ADD_PERMIT_CONDITION_CATEGORY = "ADD_PERMIT_CONDITION_CATEGORY",
  EDIT_PERMIT_CONDITION = "EDIT_PERMIT_CONDITION",
  ADD_PERMIT_CONDITION_TAG = "ADD_PERMIT_CONDITION_TAG",
  EDIT_PERMIT_CONDITION_TAG = "EDIT_PERMIT_CONDITION_TAG",
  // tailings
  ADD_TAILINGS = "ADD_TAILINGS",
  ADD_TAILINGS_STORAGE_FACILITY = "ADD_TAILINGS_STORAGE_FACILITY",
  ADD_EDIT_DAM = "ADD_EDIT_DAM",
  // documents
  REPLACE_DOCUMENT = "REPLACE_DOCUMENT",
  DELETE_DOCUMENT = "DELETE_DOCUMENT",
  ARCHIVE_DOCUMENT = "ARCHIVE_DOCUMENT",
  EDIT_HELP_GUIDE = "EDIT_HELP_GUIDE",
  INLINE_EDIT_PERMIT_CONDITION_CATEGORY = "INLINE_EDIT_PERMIT_CONDITION_CATEGORY",
  PERMIT_CONDITION_REVIEW_ASSIGNMENT = "PERMIT_CONDITION_REVIEW_ASSIGNMENT",
  PERMIT_CONDITION_SEARCH = "PERMIT_CONDITION_SEARCH",
  UPDATE_MAJOR_MINE_APPLICATION = "UPDATE_MAJOR_MINE_APPLICATION",
  UPDATE_IRT = "UPDATE_IRT",

  // Permit Generation
  GENERATE_PERMIT = "GENERATE_PERMIT",
  
  // Minespace Users
  MINESPACE_USER_ACCESS_APPROVAL = "MINESPACE_USER_ACCESS_APPROVAL",
  NEW_MINESPACE_USER = "NEW_MINESPACE_USER",
}
